import Icon from "../components/Icon";
import { formatPhoneNumber } from "../components/phoneUtils.js";

export default function Address({
  companyInfo,
  showContact = true,
  showRegistration = false,
  className = "",
}) {
  if (!companyInfo) return null;

  const { name, address, phone, email, registrationNumber } = companyInfo;
  //const cleanedNumber = formatPhoneNumber(phone);

  return (
    <address className={`not-italic ${className}`}>
      <div className="text-lg font-bold">{name}</div>
      <div className="mb-4">
        {address?.streetAddress}
        <br />
        {address?.postalCode} {address?.addressLocality}
      </div>

      {showContact && (
        <>
          {email && (
            <a
              className="flex items-center gap-2 mb-1 hover:underline"
              href={`mailto:${email}`}
            >
              <Icon name="mail" />
              <span>{email}</span>
            </a>
          )}
          {phone && (
            <a
              className="flex items-center gap-2 hover:underline"
              href={`tel:${formatPhoneNumber(phone)}`}
            >
              <Icon name="phone" />
              <span>{phone}</span>
            </a>
          )}
        </>
      )}

      {showRegistration && registrationNumber && (
        <div className="mt-4">Y-tunnus: {registrationNumber}</div>
      )}
    </address>
  );
}
